




































import {Component, Mixins, Vue, Prop, Ref} from 'vue-property-decorator';
import {Mixin} from "@/mixins";
import store from '@/store';
import axios from '@/plugins/axios';
import {captureEvent} from "@sentry/browser";

@Component({
    components: {}
})
export default class PersonalizedCartIntro extends Mixins(Mixin) {
    store = store();
    appointmentLink = appointmentLink;

    async cancel() {
        this.store.loading = true;
        try {
            const {data} = await axios.post(
                this.store.personalizedCartId
                    ? `/api/cart/cancel-personalization/${this.store.personalizedCartId}`
                    : `/api/cart/cancel-personalization`,
                {}
            );
            const {location} = data;
            if (location) {
                window.location.replace(location);
            } else {
                throw new Error('No location provided');
            }
        } catch (e) {
            captureEvent(e);
            const {href} = this.$router.resolve({name: 'cart'});
            window.location.replace(href);
        }
    }

    get expirationDate() {
        if (!this.store.serverData.personalizedCart || !this.store.serverData.personalizedCart.expirationDate) {
            return '';
        }

        return this.printDate(new Date(this.store.serverData.personalizedCart.expirationDate));
    }
}
